import {
  doc,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  collection,
  serverTimestamp,
  query,
  orderBy,
  limit,
} from 'firebase/firestore';
import { db } from '../config/firebase';

// ─── Helpers ────────────────────────────────────────────────────────────────

const updatesRef = (coachId) => collection(db, 'coaches', coachId, 'updates');
const updateDocRef = (coachId, updateId) => doc(db, 'coaches', coachId, 'updates', updateId);

// ─── Read Operations ────────────────────────────────────────────────────────

/**
 * Get coach updates, ordered by most recent first.
 */
export const getCoachUpdates = async (coachId, maxItems = 20) => {
  const q = query(
    updatesRef(coachId),
    orderBy('createdAt', 'desc'),
    limit(maxItems)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

/**
 * Get the latest coach update (convenience wrapper).
 */
export const getLatestCoachUpdate = async (coachId) => {
  const updates = await getCoachUpdates(coachId, 1);
  return updates.length > 0 ? updates[0] : null;
};

// ─── Write Operations ───────────────────────────────────────────────────────

/**
 * Create a new coach update.
 */
export const createCoachUpdate = async (coachId, data) => {
  const docRef = await addDoc(updatesRef(coachId), {
    heading: data.heading || '',
    body: data.body || '',
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
};

/**
 * Update an existing coach update.
 */
export const updateCoachUpdate = async (coachId, updateId, data) => {
  await updateDoc(updateDocRef(coachId, updateId), {
    ...data,
    updatedAt: serverTimestamp(),
  });
};

/**
 * Delete a coach update.
 */
export const deleteCoachUpdate = async (coachId, updateId) => {
  await deleteDoc(updateDocRef(coachId, updateId));
};
